import React, { useEffect, useState } from "react";
import { Col, Row, Form, Button } from "react-bootstrap";
import { AwardFill } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import {
  useCreateFoodItemMutation,
  useUploadPhotoMutation,
} from "../slices/FoodItemSilce";
import FieldWarning from "../components/FieldWarning";
import { useLocation, useNavigate } from "react-router-dom";

const CreateFoodItems = ({ outlet, creatable }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  // const location = useLocation();
  // const outletId = location.state?.outletId;
  // const createClicked = location.state?.createClicked;
  // const [outletId, setOutletId] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemCategory, setItemCategory] = useState("");
  const [originalPrice, setOriginalPrice] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [localName, setLocalName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [itemName, setItemName] = useState("");
  const [currentlySelling, setCurrentlySelling] = useState(true);
  const [discountpercent, setDiscountPercent] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [itemGst, setItemGst] = useState("");
  const [file, setFile] = useState(null);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [fileInvalidError, setFileInvalidError] = useState(false);

  // const [outletIdPresent, setOutletIdPresent] = useState(false);
  const [itemCodePresent, setItemCodePresent] = useState(false);
  const [itemCategoryPresent, setItemCategoryPresent] = useState(false);
  const [originalPricePresent, setOriginalPricePresent] = useState(false);
  const [offerPricePresent, setOfferPricePresent] = useState(false);
  const [quantityPresent, setQuantityPresent] = useState(false);
  const [itemNamePresent, setItemNamePresent] = useState(false);
  const [currentlySellingPresent, setCurrentlySellingPresent] = useState(false);
  const [localNamePresent, setLocalNamePresent] = useState(false);
  const [isVeg, setIsVeg] = useState(true);
  const [isCustomCategory, setIsCustomCategory] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [newCategoryPresent, setNewCategoryPresent] = useState(false);

  const curSale = ["Yes", "No"];
  const vegFood = ["Yes", "No"];

  let categoryOptions = [...outlet?.foodCategories, "Add New Category"];
  // categoryOptions?.push("Add New Category");

  const [addFoods, { isLoading }] = useCreateFoodItemMutation();

  const [uploadPhoto, { isLoading: isPhotoUploading }] =
    useUploadPhotoMutation();

  useEffect(() => {
    if (itemCode?.trim().length > 0) {
      setItemCodePresent(false);
    }

    if (itemCategory?.trim().length > 0) {
      setItemCategoryPresent(false);
    }

    if (originalPrice !== "" && !isNaN(Number(originalPrice))) {
      setOriginalPricePresent(false);
    }

    if (
      offerPrice !== "" &&
      !isNaN(offerPrice) &&
      Number(offerPrice) <= Number(originalPrice)
    ) {
      setOfferPricePresent(false);
    }

    if (itemName?.trim().length > 0) {
      setItemNamePresent(false);
    }
    if (quantity !== "" && !isNaN(Number(quantity))) {
      setQuantityPresent(false);
    }
    if (itemCategory === "Add New Category") {
      if (newCategory?.length > 2) {
        setNewCategoryPresent(false);
      }
    }
  }, [
    itemCode,
    itemCategory,
    originalPrice,
    offerPrice,
    quantity,
    itemName,
    currentlySelling,
    newCategory,
  ]);

  const verifyInputFields = () => {
    let fieldValidationSuccess = true;

    // console.log({
    //   outletId,
    //   itemCode,
    //   itemCategory,
    //   originalPrice,
    //   offerPrice,
    //   localCode,
    //   quantity,
    //   itemName,
    //   currentlySelling,
    // });

    if (!itemCode || itemCode.trim().length < 1) {
      setItemCodePresent(true);
      fieldValidationSuccess = false;
    }

    // if (!itemCategory || itemCategory.trim().length < 1) {
    //   setItemCategoryPresent(true);
    //   fieldValidationSuccess = false;
    // }

    if (!originalPrice?.trim() || isNaN(Number(originalPrice))) {
      setOriginalPricePresent(true);
      fieldValidationSuccess = false;
    }

    if (
      offerPrice === "" ||
      isNaN(offerPrice) ||
      Number(offerPrice) > Number(originalPrice)
    ) {
      setOfferPricePresent(true);
      fieldValidationSuccess = false;
    }

    if (!quantity?.trim() || isNaN(Number(quantity))) {
      setQuantityPresent(true);
      fieldValidationSuccess = false;
    }

    if (!itemName || itemName.trim().length < 1) {
      setItemNamePresent(true);
      fieldValidationSuccess = false;
    }

    if (currentlySelling === null) {
      setCurrentlySellingPresent(true);
      fieldValidationSuccess = false;
    }

    if (itemCategory === "Add New Category") {
      if (newCategory?.length < 2) {
        setNewCategoryPresent(true);
        fieldValidationSuccess = false;
      }
    }

    if (!fieldValidationSuccess) {
      toast.error(
        "Some of the fields have invalid inputs. Please provide valid details"
      );
    }

    return fieldValidationSuccess;
  };

  const submitHandler = async () => {
    console.log("NewCategory");
    console.log(newCategory);
    console.log("itemCategory");
    console.log(itemCategory);

    if (verifyInputFields()) {
      try {
        const resData = await addFoods({
          outletId: outlet?._id,
          itemCode: itemCode,
          isVeg: isVeg,
          itemCategory:
            itemCategory === "Add New Category"
              ? `${newCategory}_newCategory`
              : `${itemCategory}`,
          itemOriginalPrice: originalPrice,
          itemOfferPrice: offerPrice,
          itemQuantity: quantity,
          itemName: itemName,
          localName: localName,
          addedBy: userInfo?.adminName,
          currentlySelling: currentlySelling,
          discountPercent: discountpercent,
          discountAmount: discountAmount,
          gstTax: itemGst,
          token: userInfo.token,
        }).unwrap();
        if (resData && file) {
          let formData = new FormData();
          formData.append("image", file);
          formData.append("imageKey", `${resData._id}`);
          await uploadPhoto({
            token: userInfo.token,
            payload: formData,
          }).unwrap();
        }
        if (resData) {
          toast.success("Item Added Successfully");
          // createClicked(true);
          // navigate(-1);
          creatable();
          setItemCode("");
          setItemCategory("");
          setOriginalPrice("");
          setOfferPrice("");
          setLocalName("");
          setQuantity("");
          setItemName("");
          setCurrentlySelling(true);
          setDiscountPercent("");
          setDiscountAmount("");
          setItemGst("");
        }
      } catch (e) {
        toast.error(e?.data?.error || e?.error);
      }
    }
  };

  const compressImage = async (selectedImage) => {
    const file = selectedImage;
    if (file) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 280,
          useWebWorker: true,
          initialQuality: 1,
        };

        console.log("Un-Compressed file:", file);
        const compressedFile = await imageCompression(file, options);
        // setFile(compressedFile);
        console.log("first Compressed file:", compressedFile);
        const secondOptions = {
          maxSizeMB: 1, // maximum size in MB
          useWebWorker: true, // use web worker for performance
          initialQuality: 0.9, // initial quality setting
        };

        // Second compression step
        const secondCompressedFile = await imageCompression(
          compressedFile,
          secondOptions
        );
        console.log("Second Compressed file:", secondCompressedFile);
        setFile(secondCompressedFile);

        // // You can now upload the compressed file to your server
        // uploadImage(compressedFile);
      } catch (error) {
        console.error("Error processing image:", error);
      }
    }
  };

  const handleFileChange = async (e) => {
    const selectedFile = e?.target?.files[0];
    const dotIndex = selectedFile?.name?.lastIndexOf(".");
    const fileExtension = selectedFile?.name?.slice(dotIndex + 1).toLowerCase();
    let errorPresent = false;
    if (
      !(
        fileExtension === "jpeg" ||
        fileExtension === "jpg" ||
        fileExtension === "png" ||
        fileExtension === "tiff" ||
        fileExtension === "svg" ||
        fileExtension === "jfif"
      )
    ) {
      errorPresent = true;
      setFileInvalidError(true);
      setFile(null);
    } else if (selectedFile?.size / 1000 > 5120) {
      setFileSizeError(true);
      setFile(null);
    } else if (!errorPresent && selectedFile?.size / 1000 <= 5120) {
      setFileSizeError(false);
      setFileInvalidError(false);
      // setFile(selectedFile);
      await compressImage(selectedFile);
    }
  };

  return (
    <>
      <h5>Create Food Items</h5>
      <Row
        style={{
          display: "flex",
          margin: "4rem",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Row>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                Item Name<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={itemName}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^A-Za-z ]/g, "");
                  setItemName(val);
                }}
              />
              {itemNamePresent ? (
                <FieldWarning text="Please enter item code" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Item Local Name</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={localName}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^A-Za-z ]/g, "");
                  setLocalName(val);
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                Item Code<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={itemCode}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setItemCode(val);
                }}
              />
              {itemCodePresent ? (
                <FieldWarning text="Please enter item code" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" sm="3">
            <Form.Label column sm="3">
              <strong>
                Item Category<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col sm={4}>
              <Form.Select
                style={{ maxWidth: "100%" }}
                value={isCustomCategory ? "Add New Category" : itemCategory}
                onChange={(e) => {
                  const selected = e.target.value;
                  if (selected === "Add New Category") {
                    setIsCustomCategory(true);
                  } else {
                    setIsCustomCategory(false);
                  }
                  setItemCategory(selected);
                }}
              >
                <option value="">Select Category</option>
                {categoryOptions.map((category, idx) => (
                  <option key={idx} value={category}>
                    {category}
                  </option>
                ))}
              </Form.Select>
              {itemCategoryPresent && !isCustomCategory && (
                <FieldWarning text="Please select a valid category" />
              )}
            </Col>

            {isCustomCategory && (
              <Col sm={5}>
                <Form.Control
                  type="text"
                  placeholder="Enter New Category"
                  value={newCategory}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^A-Za-z ]/g, "");
                    setNewCategory(val);
                  }}
                />
                {newCategoryPresent && (
                  <FieldWarning text="Please enter New Category" />
                )}
              </Col>
            )}
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column="true" sm="3">
              <strong>
                {" "}
                Veg ?<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col sm="6">
              <div className="horizontal-radio-group">
                {vegFood?.map((option1) => (
                  <Form.Check
                    key={option1}
                    type="radio"
                    label={option1}
                    name="isVegRadio"
                    id={`isVegRadio-${option1}`}
                    value={option1}
                    checked={isVeg === (option1 === "Yes")}
                    onChange={(e) => setIsVeg(e.target.value === "Yes")}
                  />
                ))}
                {currentlySellingPresent ? (
                  <FieldWarning text="Please select one option" />
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                Original Price<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={originalPrice}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setOriginalPrice(val);
                }}
              />
              {originalPricePresent ? (
                <FieldWarning text="Please enter price" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                Offer Price<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={offerPrice}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setOfferPrice(val);
                }}
              />
              {offerPricePresent ? (
                <FieldWarning text="Offer price cannot be empty or more than original price" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                Item Quantity<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={quantity}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setQuantity(val);
                }}
              />
              {quantityPresent ? (
                <FieldWarning text="Please enter the number of items" />
              ) : (
                ""
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column="true" sm="3">
              <strong>
                {" "}
                Currently Selling ?<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col sm="6">
              <div className="horizontal-radio-group">
                {curSale?.map((option) => (
                  <Form.Check
                    key={option}
                    type="radio"
                    label={option}
                    name="platRadio"
                    id={`platRadio-${option}`}
                    value={option}
                    checked={currentlySelling === (option === "Yes")}
                    onChange={(e) =>
                      setCurrentlySelling(e.target.value === "Yes")
                    }
                  />
                ))}
                {currentlySellingPresent ? (
                  <FieldWarning text="Please select one option" />
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Discount Percentage</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={discountpercent}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setDiscountPercent(val);
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>Discount Amount</strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={discountAmount}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setDiscountAmount(val);
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} sm="3">
            <Form.Label column="true" sm="3">
              <strong>
                GST Tax<label style={{ color: "red" }}>*</label>
              </strong>
            </Form.Label>
            <Col>
              <Form.Control
                type="text"
                value={itemGst}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setItemGst(val);
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="my-2" controlId="photo">
            <Form.Label column="true" sm="4">
              upload image :
            </Form.Label>
            <Col sm="6">
              <input
                type="file"
                onChange={handleFileChange}
                style={{ color: "white" }}
              />
              {fileSizeError && (
                <label style={{ color: "red" }}>
                  Image size should be less than 5 MB, Please select different
                  Image.
                </label>
              )}
              {fileInvalidError && (
                <label style={{ color: "red" }}>
                  Only jpeg, jpg, png, tiff and svg formats are supported
                </label>
              )}
            </Col>
          </Form.Group>

          <Row
            sm="4"
            style={{
              alignItems: "center",
              justifyContent: "center",
              margin: "2rem 0rem",
            }}
          >
            <Col>
              <Button onClick={submitHandler}>Add Items</Button>
            </Col>
          </Row>
        </Row>
      </Row>
    </>
  );
};

export default CreateFoodItems;
